import React from "react";

import { Box, Card, CardContent, Skeleton, Typography } from "@mui/material";

import { Tooltip } from "../Tooltip";
import { MetricTileChangeValue } from "./MetricTileChangeValue";

interface Props {
  label: string;
  value?: number | string;
  changeValue?: number | null;
  isLoading?: boolean;
  prefix?: string;
  suffix?: string;
  changeValuePrefix?: string;
  changeValueSuffix?: string;
  tooltip?: string;
}

export function MetricTile({
  label,
  value,
  changeValue,
  changeValuePrefix,
  changeValueSuffix,
  prefix,
  suffix,
  tooltip,
  isLoading,
}: Props) {
  return (
    <Card
      sx={{
        border: 0,
        backgroundColor: "action.hover",
        position: "relative",
      }}>
      {!isLoading && (
        <CardContent>
          {tooltip && (
            <Box position="absolute" top={5} right={5} padding="3px">
              <Tooltip dataTestId="tooltip" tooltip={tooltip} />
            </Box>
          )}
          <Box display="flex" alignItems="center" mb={1}>
            <Typography variant="h3">
              {prefix}
              {value}
              {suffix}
            </Typography>
            {!!changeValue && (
              <Box ml={1}>
                <MetricTileChangeValue
                  value={changeValue}
                  prefix={changeValuePrefix}
                  suffix={changeValueSuffix}
                />
              </Box>
            )}
          </Box>
          <Typography sx={{ color: "info.main" }} variant="body2">
            {label}
          </Typography>
        </CardContent>
      )}
      {isLoading && <Skeleton height={120} variant="rectangular" />}
    </Card>
  );
}
